$(document).ready(function ()
{
	
	$("#option_top_menu").on("click", function (e)
	{
		$("#lists_menu").hide();
		$("#charts_menu").hide();
		$("#calculators_menu").hide();
		e.preventDefault();
		$("#options_menu").slideToggle(800);	
	});
	
	$("#lists_top_menu").on("click", function (e)
	{
		$("#options_menu").hide();
		$("#charts_menu").hide();
		$("#calculators_menu").hide();
		e.preventDefault();
		$("#lists_menu").slideToggle(800);	
	});
	
	$("#charts_top_menu").on("click", function (e)
	{
		$("#lists_menu").hide();
		$("#options_menu").hide();
		$("#calculators_menu").hide();
		e.preventDefault();
		$("#charts_menu").slideToggle(800);	
	});
	
	$("#calculators_top_menu").on("click", function (e)
	{
		$("#lists_menu").hide();
		$("#options_menu").hide();
		$("#charts_menu").hide();
		e.preventDefault();
		$("#calculators_menu").slideToggle(800);	
	});

});
